import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/navbar.css";
import LuthLogo from "../assets/images/luth-logo-32x32.png"; // Adjust the path as necessary

const Navbar = () => {
  return (
    <>
      <div className="fixed-header">
        <div className="newstudents-header">
          <div className="blinker">
            📢 Admission is currently ongoing into LUTH Schools
          </div>
          <Link to="/applicant-login" className="login-link">
            Login
          </Link>
        </div>

        <nav className="navbars">
          <div className="navbar-container">
            <div className="navbar-logo">
              <img src={LuthLogo} alt="LUTH Logo" className="nav-logo" />
              {/* <span>LUTH Admissions Portal</span> */}
            </div>
            <ul className="navbar-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              {/* <li>
                <Link to="/">Schools</Link>
              </li> */}
              <li>
                <Link to="/news">News & Updates</Link>
              </li>
              {/* <li>
                <Link to="/application-instructions">
                  Application Instructions
                </Link>
              </li> */}
              <li>
                <Link to="/post-utme-calendar">Post UTME Calendar</Link>
              </li>
              <li>
                <a
                  href="https://luth.gov.ng/schools"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LUTH Main Website
                </a>
              </li>
              <li>
                <Link to="/portal">School Portal</Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
